import {FileBlobResponse, FileBlobResponseFields} from "src/types/files/filesData";

export const downloadFileHelper = (downloadUrl: string, downloadName: string) => {
    const link = document.createElement('a');
    link.href = downloadUrl;

    link.setAttribute('download', downloadName);

    document.body.appendChild(link);
    link.click();
    link.remove();
}

export const downloadFileBlobHelper = (blobResponse: FileBlobResponse) => {
    const downloadUrl = window.URL.createObjectURL(new Blob([blobResponse[FileBlobResponseFields.File]]));
    downloadFileHelper(downloadUrl, blobResponse[FileBlobResponseFields.FileName]);
}
